import { api } from "../ModuloGerenciador/UrlPadrao"

export const getVideosAjuda = async (token) => {
  return api.get("videosAjuda",
  {
    headers: {
      'Authorization': token
    }
  })
}